import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const LoginHeader = () => {
    const navigate = useNavigate();

    const [form, setForm] = useState({
        username: "",
        password: "",
    });

    const [errors, setErrors] = useState({});
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);

    /* ---------------- Validation ---------------- */
    const validate = () => {
        let err = {};

        if (!form.username.trim()) {
            err.username = "Please enter username";
        }
        if (!form.password.trim()) {
            err.password = "Please enter password";
        }

        setErrors(err);
        return Object.keys(err).length === 0;
    };

    /* ---------------- Submit ---------------- */
    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");

        if (!validate()) return;

        try {
            setLoading(true);

            const res = await axios.post(
                `${baseAPIUrl}admin/login/login_submit`,
                form,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    withCredentials: true,
                }
            );

            const resp = res.data;

            if (resp.status === 1) {
                localStorage.setItem("isLoggedIn", "true");

                // save allowed school slugs (array)
                localStorage.setItem(
                    "school_slugs",
                    JSON.stringify(["tigps-main","alipurduar", "bolpur", "coochbehar", "durgapur", "falakata", "gangarampur", "hooghly", "jalpaiguri", "kolaghat", "krishnanagar", "midnapore", "nabadwip", "raiganj", "raniganj", "siliguri"])
                );
                window.location.href = "/admin/dashboard";
            } else if (resp.status === 2) {
                localStorage.setItem("isLoggedIn", "true");

                // save allowed school slugs (array)
                localStorage.setItem(
                    "school_slugs",
                    JSON.stringify(["tigps-main"])
                );
                window.location.href = "/admin/enquiry-dashboard/tigps-main";
            }else {
                setMessage(resp.msg || "Invalid login credentials");
            }
        } catch (err) {
            setMessage("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };
    return (
        <div className="login-page">
            <div className="login-box">
                <div className="login-logo">
                    <b>TIGPS</b> ADMIN
                </div>

                <div className="card">
                    <div className="card-body login-card-body">

                        {message && (
                            <p className="text-danger text-center">{message}</p>
                        )}

                        <form onSubmit={handleSubmit} noValidate>

                            {/* Username */}
                            <span className="text-danger">{errors.username}</span>
                            <div className="input-group mb-3">
                                <input
                                    type="text"
                                    className={`form-control ${errors.username ? "is-invalid" : ""}`}
                                    placeholder="Username"
                                    value={form.username}
                                    onChange={(e) =>
                                        setForm({ ...form, username: e.target.value })
                                    }
                                />
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                        <span className="fas fa-user"></span>
                                    </div>
                                </div>
                            </div>

                            {/* Password */}
                            <span className="text-danger">{errors.password}</span>
                            <div className="input-group mb-3">
                                <input
                                    type="password"
                                    className={`form-control ${errors.password ? "is-invalid" : ""}`}
                                    placeholder="Password"
                                    value={form.password}
                                    onChange={(e) =>
                                        setForm({ ...form, password: e.target.value })
                                    }
                                />
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                        <span className="fas fa-lock"></span>
                                    </div>
                                </div>
                            </div>

                            <div className="row justify-content-center">
                                <div className="col-4">
                                    <button
                                        type="submit"
                                        className="btn btn-primary btn-block"
                                        disabled={loading}
                                    >
                                        {loading ? "Signing In..." : "Sign In"}
                                    </button>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginHeader;
